import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GithubRepositoriesAccesses } from "./accesses.ts";
import { GithubRepositoriesComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that `admin` on `acme/.*` needs approval.
const GithubRepositoriesFilters = {
  organization: { keys: ["name"] },
  repository: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type GithubRepositoriesFilters = typeof GithubRepositoriesFilters;

export const GithubRepositoriesRegistration = Registration({
  accesses: GithubRepositoriesAccesses,
  category: "resource",
  components: GithubRepositoriesComponents,
  docs: {
    install: "github-repositories",
    request: "github-repositories/requesting-access",
  },
  filters: GithubRepositoriesFilters,
  flag: "enable-github-legacy-integrations",
  // The new item's form asks for the "Organization login".
  identifier: "login",
  itemKind: "Organization",
  label: "GitHub Repositories",
  logoUrl:
    "https://github.githubassets.com/assets/GitHub-Mark-ea2971cee799.png",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "repository-access" }],
});

registerIntegration("github-repositories", GithubRepositoriesRegistration);
